import { render, staticRenderFns } from "./OmnicaSidebar.vue?vue&type=template&id=35c40462&scoped=true"
import script from "./OmnicaSidebar.vue?vue&type=script&lang=js"
export * from "./OmnicaSidebar.vue?vue&type=script&lang=js"
import style0 from "./OmnicaSidebar.vue?vue&type=style&index=0&id=35c40462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c40462",
  null
  
)

export default component.exports